import { useOrganizationContext } from "@/orgs/useOrganizationContext";
import { queryOptions, skipToken, useQuery } from "@tanstack/react-query";
import { getQueryKeyForOrganization } from "../hooks/useActiveOrganizationQuery";
import { getBranding } from "../portal-api";

function getBrandingQueryKey(organizationId: number) {
  return [...getQueryKeyForOrganization(organizationId), "branding"] as const;
}

export function getBrandingQuery(organizationId: number) {
  return queryOptions({
    queryKey: getBrandingQueryKey(organizationId),
    queryFn: organizationId ? () => getBranding(organizationId) : skipToken,
    refetchOnMount: false,
  });
}

export function useBrandingQuery() {
  const organization = useOrganizationContext();

  return useQuery(getBrandingQuery(organization.id));
}
